import React from 'react';

import classNames from 'classnames';

import {Icon} from '../icon/icon';

export interface IProgressProps {
    color: TProgressColor;
    percent: number;
    className?: string;
    icon?: string;
    indicator?: number;
    label?: string;
}

export type TProgressColor = 'red' | 'blue' | 'green';

const Progress = (props: IProgressProps): JSX.Element => {
    const [isMounted, setIsMounted] = React.useState(false);

    React.useEffect(() => {
        setIsMounted(true);

        return (): void => {
            setIsMounted(false);
        };
    }, []);

    const className: string = classNames(
        'progress',
        {
            [`progress--color-${props.color}`]: !!props.color,
            'progress--align-top': !!props.label,
        },
        props.className,
    );

    return (
        <div
            className={className}
        >
            {props.icon &&
                <div className="progress__column progress__column--icon">
                    <Icon className="progress__icon" name={props.icon} />
                </div>
            }
            <div className="progress__column">
                {props.label && <p className="progress__label text-small">{props.label}</p>}
                <div className="progress__bar-container">
                    {props.indicator !== undefined && <div className="progress__indicator" style={{marginLeft: `${props.indicator}%`}} />}
                    <div className="progress__bar" style={{maxWidth: isMounted ? `${props.percent}%` : 0}} />
                </div>
            </div>
        </div>
    );
};

export default Progress;
